import React, { memo } from 'react';

import { UploadContainer } from './styles';

const Upload = memo(({ children, ...rest }) => {
  return <UploadContainer {...rest}>{children}</UploadContainer>;
});

export default Upload;
